import { Inject, Injectable, Optional } from "@angular/core";

import { MedLayoutConfig } from "../types";
import { LayoutLocalConfig } from "../components/layouts/med-layout/types.local";

export const MED_LAYOUT_CONFIG_KEY = "medLayoutConfig";

@Injectable({
  providedIn: "root",
})
export class MedLayoutService {
  constructor(@Optional() @Inject(MED_LAYOUT_CONFIG_KEY) config: MedLayoutConfig) {
    this.config = Object.assign({}, this.config, config);
  }

  scrollbarWidth = 0;
  config: LayoutLocalConfig = {
    asideLeftWidth: "215px",
    visibleAsideLeft: false,

    asideRightWidth: "200px",
    visibleAsideRight: false,

    footerHeight: "60px",
    visibleFooter: false,

    visibleBanner: false,
    bannerLink: "https://stopwarukraine.com/",

    logoLink: "#",
    logoSrc: "/assets/images/logo.svg",

    headerHeight: "82px",
    headerClassList: "",
    headerJustifyContent: "flex-start",
  };

  get offsetTop(): string {
    return `calc(${this.config.headerHeight} + var(--header-margin-bottom))`;
  }

  get offsetLeft(): string {
    return this.config.visibleAsideLeft ? this.config.asideLeftWidth : "0px";
  }

  get offsetRight(): string {
    return this.config.visibleAsideRight ? this.config.asideRightWidth : "0px";
  }

  get offsetBottom(): string {
    return this.config.visibleFooter ? this.config.footerHeight : "0px";
  }

  get headerWidth(): string {
    return `calc(100vw - ${this.scrollbarWidth}px)`;
  }

  get asideLeftFlexWidth(): string {
    return `0 0 ${this.config.asideLeftWidth}`;
  }

  get asideRightFlexWidth(): string {
    return `0 0 ${this.config.asideRightWidth}`;
  }

  get contentWidth(): string {
    return `calc(100vw - (${this.offsetLeft} + ${this.offsetRight} + ${this.scrollbarWidth}px))`;
  }

  get contentFlexWidth(): string {
    return `0 0 calc(100% - (${this.offsetLeft} + ${this.offsetRight} + ${this.scrollbarWidth}px))`;
  }

  get asideHeight(): string {
    return `calc(100vh - (var(--horizontal-scroll-height) + ${this.config.headerHeight} + ${this.offsetBottom} + var(--header-margin-bottom)))`;
  }
}
